import ExecutePopupBlob from './ExecutePopupBlob';

export default ExecutePopupBlob;
